// Shared logic for the PrizmDoc "Finalize"/"Save" (data-pcc-download) button,
// used by both the RapidReview viewer (via the redactionsManager mixin) and
// the standard document-page viewer (utils/prizmdoc/viewer.ts), which render
// the same PrizmDoc-templated button under different labels.

const FINALIZE_BUTTON_SELECTOR = "[data-pcc-download='download']"

export function setSaveBurnButtonEnabled(hasDraftRedactions) {
  if (hasDraftRedactions) {
    setSaveBurnButtonStates(false)
  } else {
    setSaveBurnButtonStates(
      true,
      'You must have redactions to finalize a document.'
    )
  }
}

export function setSaveBurnButtonStates(enabled, tooltip = '') {
  const finalizeButton = document.querySelector(FINALIZE_BUTTON_SELECTOR)
  if (finalizeButton) {
    finalizeButton.disabled = enabled
    finalizeButton.title = tooltip
  }
}

export function totalRedactionCount(viewerControl) {
  let total = 0
  viewerControl
    .getMarkupLayerCollection()
    .forEach((layer) => (total += layer.getMarks().length))
  return total
}
